// api/applicationApi.js
import apiClient, { downloadFile } from "../../../../../../services/apiClient";


export const applicationApi = {
  // Получение заявки по ID
  getApplicationById: async (applicationId) => {
    const response = await apiClient.get(`/requests/${applicationId}`);
    return response.data && response.data[0] || {};
  },

  // Получение списка заявок с фильтрацией и пагинацией
  getApplications: async (filters = {}, page = 1, limit = 20) => {
    const params = {
      page,
      limit,
      ...filters
    };
    const response = await apiClient.get('/applications', { params });
    return response.data;
  },

  // Обновление статуса заявки
  updateApplicationStatus: async (applicationId, statusData) => {
    const response = await apiClient.put(`/applications/${applicationId}/status`, statusData);
    return response.data;
  },

  // Подтверждение регистрации
  verifyRegistration: async (applicationId, comment = '') => {
    const response = await apiClient.put(`/applications/${applicationId}/verify-registration`, {
      comment,
      verifiedBy: localStorage.getItem('userId')
    });
    return response.data;
  },

  // Подтверждение льготы
  verifyBenefit: async (applicationId, benefitId, comment = '') => {
    const response = await apiClient.put(`/applications/${applicationId}/verify-benefit`, {
      benefitId,
      comment,
      verifiedBy: localStorage.getItem('userId')
    });
    return response.data;
  },

  // Отклонение заявки
  rejectApplication: async (applicationId, reason, comment = '') => {
    const response = await apiClient.put(`/applications/${applicationId}/reject`, {
      reason,
      comment,
      rejectedBy: localStorage.getItem('userId')
    });
    return response.data;
  },

  // Восстановление заявки
  restoreApplication: async (applicationId, comment = '') => {
    const response = await apiClient.put(`/applications/${applicationId}/restore`, {
      comment,
      restoredBy: localStorage.getItem('userId')
    });
    return response.data;
  },
  
  declineInvitation: async (applicationId, reason, kindergartenId, groupNumber) => {
    const response = await apiClient.post(`invite/request/${applicationId}/decline_request_invite_admin`, {
      reason,
      kindergartenId,
      groupNumber,
      declinedBy: localStorage.getItem('userId')
    });
    return response.data;
  },
    getApplicationStatuses: async (applicationId) => {
    const response = await apiClient.get(`/requests/${applicationId}/statuses`);
    return response.data;
  }
};


const url_download = (docId, fileId, path)=>`requests/${docId}/file/${fileId}/${path}`;

export const fileApi = {
  // Скачивание файла
  downloadFile: async (docId, fileId, path, fileName) => await downloadFile(url_download(docId, fileId, path), fileName),

  // Получение информации о файле
  getFileInfo: async (fileId) => {
    const response = await apiClient.get(`/files/${fileId}/info`);
    return response.data;
  },

  // Загрузка файла
  uploadFile: async (applicationId, file, fileType) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', fileType);
    
    const response = await apiClient.put(`/applications/${applicationId}/files`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }
};